/***********
 Global Discount
 ***********/

if (globalDiscount != 1 && product.gift_card == false) {
    if (product.compare_at_price == null) {
        product.compare_at_price = product.price;
    }
    product.price *= globalDiscount;
    product.variants.forEach(function (variant) {
        // compare_at_price_real helps us differentiate between an artificial sale (globalDiscount) vs actually on sale
        variant.compare_at_price_real = variant.compare_at_price;
        if (variant.compare_at_price == null) {
            variant.compare_at_price = variant.price;
        }
        variant.price *= globalDiscount;
    });
}


/***************
 Product Media
 ****************/


//preload all product images
product.images.forEach(function (image) {
    preloadImage(image.src);
});

// desktop/mobile optimizations
function productPageResize() {
    // if the height of the productActions has enought space, center it vertically
    if (window.innerWidth < 750 || document.querySelector("#productActions").offsetHeight > window.innerHeight - 70 - 30) {
        document.querySelector("#productActions").classList.remove("center");
    } else {
        document.querySelector("#productActions").classList.add("center");
    }

    //check for vertical device - apply optimizations
    if (window.innerHeight > window.innerWidth) {
        document.querySelector("#product").classList.add("verticalScreen");
        document.querySelector("#productMedia").classList.add("verticalScreen");
    }
}

window.addEventListener("resize", productPageResize);
productPageResize();

// check for sale image (cyber monday badge)
if (globalDiscount != 1 && product.gift_card == false) {
    if (document.querySelector("#productMediaCharity")) {
        //document.querySelector("#productMedia").insertAdjacentHTML("beforeend", `<div id="productMediaSale" class="left"><img id="productMediaSaleImage" src="/cdn/shop/files/cybermonday.png"></div>`);
    } else {
        //document.querySelector("#productMedia").insertAdjacentHTML("beforeend", `<div id="productMediaSale" class="right"><img id="productMediaSaleImage" src="/cdn/shop/files/cybermonday.png"></div>`);
    }
}

// check for charity
if (productHandleToCharity[product.handle]) {
    // save charity
    const charity = productHandleToCharity[product.handle];

    // append image to dom
    document.querySelector("#productMedia").insertAdjacentHTML("beforeend", `
        <img id="productMediaCharity" src="${charity.image}" alt="${charity.title} logo" style="width: ${charity.icon_width}px; height: ${charity.icon_height}px;">
    `);

    // add event listener to open modal
    document.querySelector("#productMediaCharity").addEventListener("click", function () {
        document.querySelector(`#${charity.id}`).classList.add("active");
    });
}

// setup image swiper
let productMedia = new Swiper("#productMedia");

// setup lightgallery
let productGallery;

// update product calls this to reset the media based on variant
function updateProductMedia() {

    // dsiable swiper
    productMedia.destroy();

    // reset container
    document.querySelector("#productMediaWrapper").innerHTML = "";

    // array of all the images
    let media = [];

    //if there is a featured image with an alt tag find the corresponding images
    if (correctVariant.featured_image && correctVariant.featured_image.alt) {
        //similar to the colelction page we need to establsh what alt image tags we're looking for
        let alt = correctVariant.featured_image.alt;
        alt = alt.substring(0, alt.length - 1);

        //cycle through images array and add all the matches of alt key to the array
        product.images.forEach(function (image) {
            // add thumbnail for lightgallery
            image.thumb = image.src;

            if (image.alt.substring(0, image.alt.length - 1) == alt || image.alt.includes("LS")) {
                media.push(image);
            }

            //we are also going to see if there are any earing backs that need to be added
            if (product.type == "Earring" || product.type == "Necklace") {
                if (document.querySelector(".productOptionColor.active").getAttribute("value") == "14k Yellow Gold" && image.alt == "YBACK") {
                    media.push(image);
                } else if (document.querySelector(".productOptionColor.active").getAttribute("value") == "14k Rose Gold" && image.alt == "RBACK") {
                    media.push(image);
                } else if (document.querySelector(".productOptionColor.active").getAttribute("value") == "14k White Gold" && image.alt == "WBACK") {
                    media.push(image);
                } else if (document.querySelector(".productOptionColor.active").getAttribute("value") == "Black Rhodium" && image.alt == "BBACK") {
                    media.push(image);
                } else if (document.querySelector(".productOptionColor.active").getAttribute("value") == "14k White & Yellow Gold" && image.alt == "WYBACK") {
                    media.push(image);
                } else if (document.querySelector(".productOptionColor.active").getAttribute("value") == "14k White & Rose Gold" && image.alt == "WRBACK") {
                    media.push(image);
                }
            }
        });
    } else if (product.images.length > 0) {
        product.images.forEach(function (image) {
            // add thumbnail for lightgallery
            image.thumb = image.src;
            media.push(image);
        });
    }

    // append each image to container
    media.forEach(function (image, index) {
        document.querySelector("#productMediaWrapper").insertAdjacentHTML("beforeend", `
            <img class="swiper-slide productMediaSlide" src="${image.src}" alt="${image.alt}" index="${index}">
        `);
    });

    // append video to container
    product.videos.forEach(function (video) {
        document.querySelector("#productMediaWrapper").insertAdjacentHTML("beforeend", `
            <video class="swiper-slide productMediaSlide video" autoplay loop muted playsinline poster="${video.preview_image.src}">
                <source src="${video.sources[2].url}" type="video/mp4">
            </video>
        `);
    });

    // get list of total slides
    const totalSlides = document.querySelectorAll('.productMediaSlide').length;

    //start slider
    productMedia = new Swiper("#productMedia", {
        loop: true,
        effect: "fade",
        // disable swiper's a11y module: it adds role="group" to the <img> slides, which is an invalid role for images
        a11y: false,
        navigation: {
            nextEl: "#productMediaNext",
            prevEl: "#productMediaPrev",
        }
    });

    // function to update slider arrow color
    async function updateSliderArrows() {
        // wait for swiper to update classes
        await sleep(100);

        // get brightness of active image
        const brightness = await getBrightness(document.querySelector("#productMedia .swiper-slide-active").src);

        // update arrow color
        if (brightness < 190 && product.handle !== "neilmed-piercing-aftercare-fine-mist") {
            document.querySelector("#productMedia .swiper-button-next").classList.add("light");
            document.querySelector("#productMedia .swiper-button-prev").classList.add("light");
        } else {
            document.querySelector("#productMedia .swiper-button-next").classList.remove("light");
            document.querySelector("#productMedia .swiper-button-prev").classList.remove("light");
        }

        // hide zoom icon on video if it's on the last sldie
        if (document.querySelector(`.productMediaSlide.video.swiper-slide-active`)) {
            document.querySelector("#productMediaZoom").classList.remove("active");
        } else {
            document.querySelector("#productMediaZoom").classList.add("active");
        }
    }

    // function to update the progress bar based on what slide we're on
    function updateSliderProgress() {
        // calculate the progress
        const progress = (productMedia.realIndex + 1) / totalSlides;

        // update the progress bar
        document.querySelector("#productMediaProgressInner").style.width = `${progress * 100}%`;
    }

    // slide change
    productMedia.on("slideChange", updateSliderArrows);
    productMedia.on("slideChange", updateSliderProgress);
    updateSliderArrows();
    updateSliderProgress();

    // setup light gallery
    productGallery = lightGallery(document.querySelector("#productMedia"), {
        licenseKey: "C5D4BF5A-A2984DAA-BF07D480-507474ED",
        plugins: [lgVideo, lgZoom, lgThumbnail],
        dynamic: true,
        dynamicEl: media,
        download: false,
        mobileSettings: {
            controls: false
        }
    });

    // open light gallery
    document.querySelectorAll("#productMedia .productMediaSlide:not(.video)").forEach(function (element) {
        element.addEventListener("click", function () {
            productGallery.openGallery(parseInt(this.getAttribute("index")));
        })
    });

    // change swiper when the light gallery changes
    document.querySelector("#productMedia").addEventListener("lgAfterSlide", function (e) {
        productMedia.slideTo(e.detail.index + 1);
    });


}

// function used to determine primary color of active image
// https://stackoverflow.com/a/13763063
async function getBrightness(imageSrc) {
    const img = document.createElement("img");
    img.src = imageSrc;
    img.crossOrigin = 'anonymous';
    img.style.display = "none";
    document.body.appendChild(img);
    let colorSum = 0;

    // create a promise that resolves when the image loads and brightness is calculated
    return new Promise((resolve) => {
        img.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = this.width;
            canvas.height = this.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            let r, g, b, avg;

            for (let x = 0, len = data.length; x < len; x += 4) {
                r = data[x];
                g = data[x + 1];
                b = data[x + 2];
                avg = Math.floor((r + g + b) / 3);
                colorSum += avg;
            }

            resolve(Math.floor(colorSum / (this.width * this.height)));
        }
    });
}


/***************
 Product Form
 ****************/

//check if this is a customizable product
let personalize = false;
for (let i = 0; i < product.tags.length; i++) {
    if (product.tags[i].includes("Personalize")) {
        personalize = true;

        //apend cusotmize input
        let maxLength = parseInt(product.tags[0].replace("Personalize", ""));
        document.querySelector("#productOptions").insertAdjacentHTML("beforeend", `
                <div class="productOption">
                    <div class="productOptionTitle">Personalize</div>
                    <input id="productPersonalize" placeholder="Type something..." maxlength="${maxLength}">
                    <div id="productPersonalizeCount">${maxLength}</div>
                </div>
            `);

        //key up event listener
        document.querySelector("#productPersonalize").addEventListener("keyup", function () {
            //update count
            document.querySelector("#productPersonalizeCount").textContent = maxLength - parseInt(document.querySelector("#productPersonalize").value.length);

            //update product (not images) so the product stock notice is updated
            updateProduct(true);
        });

        break;
    }
}

// setup quantity
let quantity = 1;
// 14k Earring Backing also gets quantity option
if ((product.type == "Earring" || product.id == 6548240269387) && product.tags.includes("Pair") == false) {
    //  show quantity selector
    document.querySelector("#quantitySelector").classList.add("active");

    // add event listener
    document.querySelectorAll("#quantitySelector > [quantity]").forEach(function (element) {
        element.addEventListener("click", function () {
            //make sure it's not already active
            if (this != document.querySelector("#quantitySelector > [quantity].active")) {
                document.querySelector("#quantitySelector > [quantity].active").classList.remove("active");
                this.classList.add("active");
                quantity = this.getAttribute("quantity");
                updateProduct(true);
            }
        });
    });
}

// function that will update the selected divs/dropdowns
function setActiveVariant(variantID) {
    // confirm variant provided is valid
    if (product.variants.map(variant => variant.id).includes(variantID) == false) {
        return;
    }

    // remove all active variants
    document.querySelectorAll(`.productOption > div[value]`).forEach(function (element) {
        element.classList.remove("active");
    });

    //select first avlaible varaint
    for (let i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id == variantID) {
            //once we find a match, select the corresponding variants
            product.variants[i].options.forEach(function (option) {
                // set div to active
                document.querySelector(`.productOption > div[value='${option}']`).classList.add("active");
                // if there is a select update that too
                let selectElement = document.querySelector(`.productOption > div[value='${option}']`).parentElement.querySelector("select");
                if (selectElement) {
                    selectElement.value = option;
                }
            });
            break;
        }
    }
}

//event listener for options divs
document.querySelectorAll(`.productOption > div[value]`).forEach(function (element) {
    element.addEventListener("click", function () {
        //remove active sibling
        this.parentElement.querySelector("div[value].active").classList.remove("active");
        this.classList.add("active");
        updateProduct();
    });
});

// event listener for drop down select
document.querySelectorAll(`.productOptionSelect`).forEach(function (element) {
    element.addEventListener("change", function () {
        // click on hidden div to trigger above event listener
        this.parentElement.querySelector(`div[value="${this.value}"]`).click();
    });
});

//add event listner for hover affect
let timerInterval;
document.querySelectorAll(`.productOption > div[value]`).forEach(function (element) {
    //only run if color or stone
    if (element.classList.contains("productOptionColor") || element.classList.contains("productOptionStone")) {
        //check for mobile
        if (window.innerWidth < 750) {
            //click (for mobile)
            element.addEventListener("click", function () {
                //check for element and clearInterval
                if (document.querySelector("#productOptionHover")) {
                    document.querySelector("#productOptionHover").remove();
                }
                clearInterval(timerInterval)

                this.insertAdjacentHTML("beforeend", `<div id="productOptionHover">${this.getAttribute("value")}</div>`);
                let timer = 0;
                timerInterval = setInterval(function () {
                    timer++;
                    if (timer == 2) {
                        document.querySelector("#productOptionHover").remove();
                        clearInterval(timerInterval);
                    }
                }, 1000);

            });
        } else {
            //mosue on (assuming not mobile)
            element.addEventListener("mouseover", function () {
                this.insertAdjacentHTML("beforeend", `<div id="productOptionHover">${this.getAttribute("value")}</div>`);
            });
        }

        //mouse off
        element.addEventListener("mouseout", function () {
            //check for element and clearInterval
            if (document.querySelector("#productOptionHover")) {
                document.querySelector("#productOptionHover").remove();
            }
            clearInterval(timerInterval)
        });
    }
});


//update product after option click OR inital run
let correctVariant;

function updateProduct(ignoreImages) {
    //get all active options
    let variantString = "";
    document.querySelectorAll(".productOption > div.active").forEach(function (element, index) {
        if (index == 0) {
            variantString += `${element.getAttribute("value")}`;
        } else {
            variantString += ` / ${element.getAttribute("value")}`;
        }
    });

    //find correct variant
    let correctVariantFound = false;
    for (let i = 0; i < product.variants.length; i++) {
        if (product.variants[i].title == variantString) {
            correctVariant = product.variants[i];
            correctVariantFound = true;
            break;
        }
    }

    // only if the correct variant is still false we return
    if (correctVariantFound == false) {
        document.querySelector("#productCheckout").classList.add("disabled");
        document.querySelector("#productStock").textContent = "";
        document.querySelector("#productHint").classList.add("disabled");
        document.querySelector("#productCheckout").textContent = "Not Available";
        return;
    }

    // this variable will be used to determine if we need to prevent the variant from being purchased
    let preventVariantPurchase = false;

    // check if we're blocking out of stock purchases
    if (settings.allow_out_of_stock === false && correctVariant.inventory < 1) {
        preventVariantPurchase = true;
    }

    // if there's a compare at price and no inventory, they don't plan on re-stocking so it's sold out
    if (correctVariant.compare_at_price != null && correctVariant.inventory < 1) {
        preventVariantPurchase = true;
    }

    // enable checkout button and drop a hint
    document.querySelector("#productCheckout").classList.remove("disabled");
    document.querySelector("#productHint").classList.remove("disabled");

    // prevent variant purchase if needed
    if (preventVariantPurchase === true) {
        document.querySelector("#productCheckout").textContent = "Notify Me";
        document.querySelector("#productCheckout").classList.add("soldOut");
    } else {
        document.querySelector("#productCheckout").textContent = "Add To Bag"
        document.querySelector("#productCheckout").classList.remove("soldOut");
    }

    //update price
    document.querySelector("#productPrice").textContent = price(correctVariant.price * quantity);

    //if there is a compare price, update it
    if (correctVariant.compare_at_price) {
        document.querySelector("#productComparePrice").textContent = price(correctVariant.compare_at_price * quantity);
        document.querySelector("#productPrice").classList.add("sale");
    } else {
        document.querySelector("#productComparePrice").textContent = "";
        document.querySelector("#productPrice").classList.remove("sale");
    }

    //check if product is being personalized prior to updating product stock notice
    let personalized = false;
    if (document.querySelector("#productPersonalize") && document.querySelector("#productPersonalize").value.length > 0) {
        personalized = true;
    }

    //update made to order so long as preventVariantPurchase is false
    if (preventVariantPurchase == false) {
        //check is there is a gift card in the cart
        if (product.gift_card) {
            document.querySelector("#productStock").innerHTML = `
                <div id="productQuickShip" class="quickShip active giftCard"><i class="fa-solid fa-bolt-lightning"></i> Instant Delivery</div>
            `;
        }
        //check if the quantity is greather than what's in stock
        else if (quantity <= correctVariant.inventory && !personalized) {
            document.querySelector("#productStock").innerHTML = `
                <div id="productQuickShip" class="quickShip active"><i class="fa-solid fa-bolt-lightning"></i> In stock & ready to ship</div>
            `;
        } else {
            document.querySelector("#productStock").innerHTML = `
                <span id="productStockWarning"></span>
                Made to order: ships in ${settings.mto}
                <span id="productStockIcon">
                    <i class="fal fa-info-circle"></i>
                </span>
            `;
            document.querySelector("#productStockIcon").addEventListener("click", function () {
                document.querySelector("body").classList.add("noScroll");
                document.querySelector("#stockModal").classList.add("active");
            })
        }
    } else {
        document.querySelector("#productStock").innerHTML = `
            <span id="productStockSoldOut"></span>
            Out of Stock
        `;
    }

    //update variant id in hash
    history.replaceState(undefined, undefined, `?variant=${correctVariant.id}`)

    //no need to update the images when updating from single to pair
    if (ignoreImages == undefined) {
        updateProductMedia();
    }

    //update sticky bar
    updateStickyBar();

    // update letters if needed to the new color
    if (document.querySelector("#productLetters")) {
        document.querySelectorAll(".productOptionLetter").forEach(element => {
            element.setAttribute("color", correctVariant.options[0]);
        });
    }
}

// when DOM is fully loaded load product
document.addEventListener("DOMContentLoaded", function () {
    updateProduct();
});

// listen for E-Gift toggle
if (product.gift_card) {
    document.querySelector('#productGiftFormControlsSwitchInput').addEventListener('change', function () {
        // if checked, show form
        if (this.checked) {
            document.querySelector('#productGiftFormWrap').classList.add('active');
            document.querySelector('.productGiftFormControlsTitle.default').classList.remove('active');
            document.querySelector('.productGiftFormControlsTitle.gift').classList.add('active');

        } else {
            document.querySelector('#productGiftFormWrap').classList.remove('active');
            document.querySelector('.productGiftFormControlsTitle.default').classList.add('active');
            document.querySelector('.productGiftFormControlsTitle.gift').classList.remove('active');
        }

    });

    // listen for E-gift button
    document.querySelector('#productGiftFormControlsLeft').addEventListener('click', function () {
        // click toggle button
        document.querySelector('#productGiftFormControlsSwitchInput').click()
    });


    // setup flat pickr
    document.addEventListener("DOMContentLoaded", async function () {
        let today = new Date();
        flatpickr(document.querySelector('.giftInput.date'), {
            dateFormat: "m/d/Y",
            minDate: today,
            disableMobile: "true"
        });
    });

    // for each gift input, add event listener to update gift inputs
    document.querySelectorAll('.giftInput').forEach(input => {
        input.addEventListener('input', updateGiftInputs);
    });

    // on load, update gift inputs
    updateGiftInputs();


    function updateGiftInputs() {
        // for each gift input, add active class if value isn't blank
        document.querySelectorAll('.giftInput').forEach(input => {
            let label = input.closest('.productGiftFormItem')?.querySelector('.productGiftFormItemLabel');

            if (input.value) {
                label?.classList.add('active');
            } else {
                label?.classList.remove('active');
            }

        });
    }
}

// pre-select $500 gift card
if (product.gift_card) {
    document.querySelector(".productOptionSelect").value = "$500";
    document.querySelector(".productOptionSelect").dispatchEvent(new Event("change"));
}

/***********
 Product Checkout
 *************/

//checkout button
let productFormData = {};
document.querySelector("#productCheckout").addEventListener("click", async function () {
    // if sold out, open the notify BIS modal
    if (this.classList.contains("soldOut")) {
        // show modal and apply noScroll class
        document.querySelector("#notifyModal").open();

        // make sure the form is active
        document.querySelector("#notifyModalForm").classList.add("active");
        document.querySelector("#notifyModalSuccess").classList.remove("active");

        // update modal image to correct variant image
        document.querySelector("#notifyModalImage").setAttribute("src", correctVariant.featured_image.src);

        // update description
        document.querySelector("#notifyModalDescription").textContent = `The ${product.title} in ${correctVariant.options.join(", ")} is currently out of stock. Enter your email to get notified when this product is back in stock!`;
        return;
    }

    // determine productFormData
    productFormData = {
        quantity: quantity,
        id: correctVariant.id
    };

    // add personalization if it exists
    if (personalize && document.querySelector("#productPersonalize").value.length > 0) {
        productFormData.properties = {
            'Personalize': document.querySelector("#productPersonalize").value
        }
    }

    // Gift card logic
    if (product.gift_card) {
        // check if required fields empty for E-Gift
        let errors = [];
        if (document.querySelector('#productGiftFormControlsSwitchInput').checked) {
            document.querySelectorAll('.giftInput').forEach(input => {
                if (input.required && !input.value) {
                    errors.push(input.ariaLabel);
                }
            });
        }

        // if errors, show alert and return
        if (errors.length > 0) {
            alert(`Please fill out the following fields: ${errors.join(', ')}`);
            return;
        }

        // Check for valid Email
        let email = document.querySelector('.giftInput.email').value;
        let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let validEmail = emailRegex.test(email);

        if (!validEmail && document.querySelector('#productGiftFormControlsSwitchInput').checked) {
            alert("Please use a valid email.");
            return;
        }

        // add gift card to formData
        if (document.querySelector('#productGiftFormControlsSwitchInput').checked) {
            // convert MM-DD-YYYY to YYYY-MM-DD
            const date = new Date(document.querySelector('.giftInput.date').value);
            const formattedDate = date.toISOString().split('T')[0];

            // add gift card properties
            productFormData.properties = {
                "Recipient name": document.querySelector("#productGiftFormItemName").value,
                "Recipient email": document.querySelector("#productGiftFormItemEmail").value,
                "Message": document.querySelector("#productGiftFormItemTextarea").value,
                "Send on": formattedDate,
                "__shopify_send_gift_card_to_recipient": true
            };
        }
    }

    // check if we need to block out of stock purchases
    if (settings.allow_out_of_stock === false) {
        // get cart
        const cart = await fetch("/cart?view=json-feed")
            .then(data => data.json());

        // loop through each line item and check if we're at the limit
        for (const item of cart.items) {
            if (
                correctVariant.id === item.variant_id && // must be this variant
                item.quantity + parseInt(quantity) > item.inventory // check if the line item has more quantity than we have inventory in stock
            ) {
                alert(settings.block_made_to_order_message);
                return;
            }
        }
    }

    // add product to cart
    await addProduct(productFormData);

    // open cart
    await openCart();

    // klaviyo add to cart event
    _learnq.push(['track', 'Added to Cart', item]);
});

//setup wishlist
downloadWishlist()
    .then(function () {
        setupWishlist(document.querySelector(`#productWishlist`), product);
    })


/**************
 Notification
 **************/

//made to order sign for alert
document.querySelector("#notifyModalForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // create formdata
    let formData = new FormData(this);
    formData.set("productID", product.id);
    formData.set("variantID", correctVariant.id);

    // start loading
    document.querySelector("#notifyModalFormSubmit").classList.add("loading");

    // send request to Klaviyo
    await sendKlaviyoBackInStockRequest(formData.get("email"), formData.get("variantID"));

    // send request to our DB
    const response = await fetch("https://api.aliweissjewelry.com/stock-alert/add.php", {
        method: "POST",
        body: formData
    })
        .then(response => response.json())

    // stop loading
    document.querySelector("#notifyModalFormSubmit").classList.remove("loading");

    // check for error
    if (response.error) {
        alert(response.error);
        return;
    }

    // hide form and show success message
    document.querySelector(`#notifyModalForm`).classList.remove("active");
    document.querySelector(`#notifyModalSuccess`).classList.add("active");

    // reset form
    this.reset();
});

/***********
 Product Tabs
 ************/

//product tab
document.querySelectorAll(".productTab").forEach(function (element) {
    element.addEventListener("click", function () {
        //is this current one open, if so close
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            this.nextElementSibling.removeAttribute("style");
        } else {
            //check if already open
            if (document.querySelector(".productTab.active")) {
                document.querySelector(".productTab.active").nextElementSibling.removeAttribute("style");
                document.querySelector(".productTab.active").classList.remove("active");
            }
            this.classList.add("active");
            this.nextElementSibling.style.height = `${this.nextElementSibling.scrollHeight}px `;
        }
    });
});


/***********
 Sticky Bar
 ************/

//sticky bar scroll (desktop) 70 for nav plus 10 for buffer
window.addEventListener("scroll", function () {
    // scroll element position changes if the related section is active
    let scrollHeight = document.querySelector("#productCheckout").offsetTop;
    if (document.querySelector("#related").classList.contains("active")) {
        scrollHeight = document.querySelector("#related").offsetTop;
    }

    /*
    two things must be true
    1) must scroll far enough
    2) correctVariant must be set from the updateProdct function
    */
    //must be scrolled far enough and the correctVariant needs to be set
    if (window.pageYOffset > scrollHeight + 80 && correctVariant != null) {

        //so this is a bit confusing but we are looking for when the BOTTOM of the screen is passed the footer
        //pageYOffset needs to be added to innerHeight
        if (window.pageYOffset + window.innerHeight > document.querySelector("#footer").offsetTop + document.querySelector("#productStickyBar").offsetHeight) {
            document.querySelector("#productStickyBar").classList.add("dark");
        } else {
            document.querySelector("#productStickyBar").classList.remove("dark");
        }

        document.querySelector("#productStickyBar").classList.add("active");

        if (document.querySelector("#tolstoyWidgetElement")) {
            document.querySelector("#tolstoyWidgetElement").classList.add("sticky");
        }
    } else {
        document.querySelector("#productStickyBar").classList.remove("active");
        if (document.querySelector("#tolstoyWidgetElement")) {
            document.querySelector("#tolstoyWidgetElement").classList.remove("sticky");
        }
    }
});

function updateStickyBar() {
    //product sticky bar
    function productStickyBarOptions() {
        if (correctVariant.title == "Default Title") {
            return "";
        }

        let productStickyBarOptionsHTML = "";
        for (let i = 0; i < correctVariant.options.length; i++) {
            productStickyBarOptionsHTML += ` <div> ${correctVariant.options[i]} </div>`;
            if (correctVariant.options[i + 1]) {
                productStickyBarOptionsHTML += `<div class="productStickyBarOptionsIcon"><i class="fas fa-circle fa-xs"></i></div>`;
            }
        }
        return productStickyBarOptionsHTML;
    }

    document.querySelector("#productStickyBarContent").innerHTML = `
			<img id="productStickyBarImage" src="${correctVariant.featured_image.src}" alt="${correctVariant.featured_image.alt}">
			<div id="productStickyBarProductInfo">
				<div id="productStickyBarTitle">${product.title}</div>
				<div id="productStickyBarOptions">${productStickyBarOptions()}</div>
			</div>
			<div id="productStickyBarPriceInfo">
				<div id="productStickyBarPrice" class="${document.querySelector("#productPrice").classList.toString()}">${document.querySelector("#productPrice").textContent}</div>
				<div id="productStickyBarComparePrice">${document.querySelector("#productComparePrice").textContent}</div>
			</div>
            ${document.querySelector("#productCheckout").outerHTML.replace("productCheckout", "productStickyBarCheckout")}
		`;

    //product sticky bar mirror
    document.querySelector("#productStickyBarCheckout").addEventListener("click", function () {
        document.querySelector("#productCheckout").click();
    });
}